import React from "react";

import { authRoles } from "app/auth";

import i18next from "i18next";

import vi from "./i18n/vi";
import en from "./i18n/en";
import { isMobileOnly } from "react-device-detect";

i18next.addResourceBundle("vi", "insights", vi);
i18next.addResourceBundle("en", "insights", en);

const InsightConfig = {
  settings: {
    layout: "admin",
  },
  auth: authRoles.user,
  routes: [
    {
      path: "/insights",
      exact: true,
      component: React.lazy(() =>
        isMobileOnly ? import("./insights.mobile") : import("./insights")
      ),
    },
  ],
};

export default InsightConfig;
